import { get } from 'lodash';

const styles = (theme) => ({
  statusFilter: {
    minWidth: '200px',
    marginTop: "1.5rem !important",
    marginLeft: "1rem !important",
  },
  status: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '&:before': {
      content: '""',
      width: '12px',
      height: '12px',
      borderRadius: '50%',
    },
  },
  nameFilter: {
    minWidth: "200px",
  },
  warning: {
    '&:before': {
      backgroundColor: get(theme, 'color.warning'),
    },
  },
  success: {
    '&:before': {
      backgroundColor: get(theme, 'color.success'),
    },
  },
  alertMessagesContainer: {
    marginLeft: 36,
    width: "93% !important",
  },
  flex: {
    display: 'flex !important',
    alignItems: "center !important",
    justifyContent: "none",
  },
  helpIcon: {
    width: "24px !important",
    paddingLeft: get(theme, 'padding.p5'),

  },
})

export default styles;